import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  picture: '',
  documentType: '',
  guestList: [],
  selectedGuest: {},
  guestHolder: {},
  customGuestId: {},
  dataResidence: {
    phoneKey: {},
    phoneNumber: '',
    email: '',
    country: {},
    state: {},
    zipCode: '',
  },
  dataContract: {
    sign: '',
    acceptContract: false,
    acceptWelcome: false,
    acceptAntiDrogs: false,
    acceptTerms: false,
  },
  showErrorModal: false,
  guestErrorMessage: '',
};

const guestsSlice = createSlice({
  name: 'guests',
  initialState,
  reducers: {
    setPicture(state, { payload }) {
      state.picture = payload;
    },
    setDocumentType(state, { payload }) {
      state.documentType = payload;
    },
    setGuestList(state, { payload }) {
      state.guestList = payload;
    },
    setSelectedGuest(state, { payload }) {
      state.selectedGuest = payload;
    },
    setCustomGuestId(state, { payload }) {
      state.customGuestId = payload;
    },
    setDataResidence(state, { payload }) {
      state.dataResidence = payload;
    },
    setDataContract(state, { payload }) {
      state.dataContract = payload;
    },
    setGuestHolder(state, { payload }) {
      state.guestHolder = payload;
    },
    setGuestErrorMessage(state, { payload }) {
      state.guestErrorMessage = payload.message;
      state.showErrorModal = payload.showErrorModal || false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_GUESTS_STATE', () => initialState);
  },
});

export const {
  setPicture,
  setDocumentType,
  setGuestList,
  setSelectedGuest,
  setCustomGuestId,
  setDataResidence,
  setDataContract,
  setGuestHolder,
  setGuestErrorMessage,
} = guestsSlice.actions;
export default guestsSlice.reducer;
